import Button from './Button'

export type { ButtonVariant } from './Button'
export { StyledButton as BaseButton, BUTTON_COLORS } from './Button'
export default Button
